import _sfc_main from './src/text.vue2.mjs';
export { textProps } from './src/text.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElText = withInstall(_sfc_main);

export { ElText, ElText as default };
//# sourceMappingURL=index.mjs.map
